import { t } from '../../common/translations';

const replaceSpaceWithCharSpace = (string) => string.replaceAll(' ', '%20');

function fillContactUsWhatsAppWithDates({ document }) {
  const modalContactUsBtnEls = document.querySelectorAll('.modal-contact-us-whatsapp-link');
  modalContactUsBtnEls.forEach(btn => {
    btn.addEventListener('click', addDatesToWhatsAppMessage);
  });
}

const addDatesToWhatsAppMessage = () => {
  const breakdownPaymentType = t(`checkout_page.checkout_form.fields.payment_types.${document.querySelector('.breakdown-payment-type').value}`);
  const whatappPaymentType = replaceSpaceWithCharSpace(t('contact.whatsapp_text_info_payment_type', { payment_type: breakdownPaymentType }));
  const modalContactUsWhatsAppLinkEl = document.querySelectorAll('.modal-contact-us-whatsapp-link');
  const endDateText = document.querySelector('.date__span.date__span-end_date').textContent;
  const endDate = endDateText ? `&end_date=${endDateText}` : '';
  const iniDateText = document.querySelector('.date__span.date__span-ini_date').textContent;
  const startDate = iniDateText ? `&start_date=${iniDateText}` : '';
  const buttonType = t('campaign_tracker.button_type.sales');
  const websiteUrl = location.href;
  const propertyId = websiteUrl.split('/').at(-1);

  const campaingTrackerHrefUrl = `/whatsapp_redirect?property_id=${propertyId}&button_type=${buttonType}${startDate}${endDate}`;

  modalContactUsWhatsAppLinkEl.forEach(el => {
    el.href = `${campaingTrackerHrefUrl}%20${whatappPaymentType}`;
  });
};

export default fillContactUsWhatsAppWithDates;
